import { CanActivateFn } from '@angular/router';

export const LINKEDIN_CLICK_ID_COOKIE = 'li_fat_id';

let capturedClickId: string | null = null;

export function captureLinkedInClickId(): void {
	const fromUrl = new URLSearchParams(window.location.search);
	const liFatId = fromUrl.get('li_fat_id');
	const utmSource = fromUrl.get('utm_source');

	if (!liFatId || capturedClickId === liFatId) {
		return;
	}

	capturedClickId = liFatId;

	const payload = {
		event: 'linkedin_paid_landing',
		event_category: 'acquisition',
		linkedin_click_id: liFatId,
		campaign_source: utmSource || 'linkedin',
	};

	const windowObj = window as any;
	windowObj.dataLayer = windowObj.dataLayer || [];
	windowObj.dataLayer.push(payload);

	const maxAge = 30 * 24 * 60 * 60;
	const secure = window.location.protocol === 'https:' ? '; Secure' : '';
	document.cookie = `${LINKEDIN_CLICK_ID_COOKIE}=${encodeURIComponent(liFatId)}; path=/; max-age=${maxAge}; SameSite=Lax${secure}`;
}

export const linkedinCaptureGuard: CanActivateFn = () => {
	captureLinkedInClickId();
	return true;
};
